import {
  People as PeopleIcon,
  Security as SecurityIcon
} from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Grid,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 4 }}>
        Área Administrativa
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <PeopleIcon sx={{ fontSize: 48, color: 'primary.main', mr: 2 }} />
                <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
                  Gestão de Usuários
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Gerencie usuários do sistema: criar, editar, bloquear, desbloquear e atribuir roles.
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                size="large"
                variant="contained"
                fullWidth
                onClick={() => navigate('/admin/usuarios')}
              >
                Acessar Gestão de Usuários
              </Button>
            </CardActions>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <SecurityIcon sx={{ fontSize: 48, color: 'primary.main', mr: 2 }} />
                <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
                  Gestão de Roles
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Gerencie roles do sistema: criar, editar e excluir roles de permissão.
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                size="large"
                variant="contained"
                fullWidth
                onClick={() => navigate('/admin/roles')}
              >
                Acessar Gestão de Roles
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AdminDashboard;




